// Schema - requires both from and to fields to be non-empty

import z from "zod";
import { providerConnectionInfoFieldSchema } from "./integrations";

export const singleFieldMappingSchema = z.object({
  from: providerConnectionInfoFieldSchema.nullable(),
  to: providerConnectionInfoFieldSchema.nullable(),
  update: z.boolean(),
  locked: z.boolean().optional(),
});

export type SingleFieldMapping = z.infer<typeof singleFieldMappingSchema>;

export type FieldsForm = {
  fieldMappings: {
    [mappingGroup: string]:
      | {
          [compositeKey: string]: SingleFieldMapping[] | undefined;
        }
      | undefined;
  };
};

export const fieldsFormSchema = z.object({
  fieldMappings: z.record(
    z.string(),
    z
      .record(z.string(), z.array(singleFieldMappingSchema).optional())
      .optional(),
  ),
}) satisfies z.ZodType<FieldsForm>;
